import React from "react"
import dayjs from "dayjs"
import { LeaveTimeline } from "components/new-stuff/leave-timeline"
import type {
  LeaveTimelineBar,
  LeaveTimelineDayFlag,
  LeaveTimelineRow,
} from "components/new-stuff/leave-timeline"

/**
 * SCRATCH — not committed. Renders the timeline at realistic scale with fixed data so the
 * grid can be looked at without a database behind it.
 */

const START = dayjs("2026-06-01")
const DAYS = 45

const PEOPLE = [
  "Adaeze Okonkwo",
  "Bimbo Adeyemi",
  "Chidi Nwosu",
  "Damilola Ajayi",
  "Emeka Obi",
  "Funke Balogun",
  "Gbenga Oladipo",
  "Halima Yusuf",
  "Ibrahim Sani",
  "Jumoke Alabi",
  "Kelechi Eze",
  "Lola Fashola",
]

const rows: LeaveTimelineRow[] = PEOPLE.map((name, i) => ({
  id: i + 1,
  name,
  subtitle: i === 0 ? "This request" : undefined,
}))

function span(rowId: number, offset: number, length: number, kind: LeaveTimelineBar["kind"]) {
  const start = START.add(offset, "day")
  return {
    id: `${rowId}-${offset}`,
    rowId,
    startDate: start.format("YYYY-MM-DD"),
    endDate: start.add(length - 1, "day").format("YYYY-MM-DD"),
    kind,
    label: `${PEOPLE[rowId - 1]} — ${kind}`,
  } as LeaveTimelineBar
}

const bars: LeaveTimelineBar[] = [
  span(1, 8, 7, "focus"),
  span(2, 6, 5, "approved"),
  span(3, 9, 4, "approved"),
  span(4, 10, 6, "pending"),
  span(5, 2, 3, "approved"),
  span(6, 20, 10, "planned"),
  span(7, 25, 5, "planned"),
  span(8, 30, 8, "approved"),
  span(9, 12, 2, "pending"),
  span(10, 33, 6, "planned"),
  span(11, 0, 4, "approved"),
  span(12, 38, 7, "approved"),
]

// Days 8-12 have four people out at once against a threshold of 3.
const dayFlags: LeaveTimelineDayFlag[] = Array.from({ length: DAYS }).map((_, i) => {
  const date = START.add(i, "day")
  const breach = i >= 9 && i <= 12
  return {
    date: date.format("YYYY-MM-DD"),
    exceedsThreshold: breach,
    absentCount: breach ? 4 : 1,
  }
})

const LeaveTimelinePreview: React.FC = () => (
  <div className="p-8 bg-[#f8fafc] min-h-screen">
    <h1 className="font-circular text-xl mb-1">Leave timeline — preview</h1>
    <p className="font-avenir text-sm text-padeSubtext mb-6">
      12 people, 45 days, threshold of 3. Scratch page, not committed.
    </p>
    <LeaveTimeline
      rows={rows}
      bars={bars}
      dayFlags={dayFlags}
      startDate={START.format("YYYY-MM-DD")}
      endDate={START.add(DAYS - 1, "day").format("YYYY-MM-DD")}
      thresholdLabel="Up to 3 away at once in Engineering"
    />
  </div>
)

export default LeaveTimelinePreview
